import { createFeatureSelector, createSelector } from '@ngrx/store';
import { projectsFeatureKey, ProjectsState } from './projects.reducer';

export const selectProjectsState =
  createFeatureSelector<ProjectsState>(projectsFeatureKey);

export const selectAllProjects = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.projects
);

export const selectProjectsSearchResult = createSelector(
  selectProjectsState,
  (state: ProjectsState) => ({
    projects: state.projects,
    qtyOfProjects: state.qtyOfProjects,
    qtyOfActiveProjects: state.qtyOfActiveProjects,
    qtyOfInactiveProjects: state.qtyOfInactiveProjects,
    qtyOfProjectsForCurrentUser: state.qtyOfProjectsForCurrentUser,
    projectEvents: state.projectEvents,
    searchRequest: state.searchRequest,
    focusedProject: state.focusedProject
  })
);

export const selectQtyOfInactiveProjects = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.qtyOfInactiveProjects
);

export const selectQtyOfActiveProjects = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.qtyOfActiveProjects
);

export const selectQtyOfProjectsForCurrentUser = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.qtyOfProjectsForCurrentUser
);

export const selectProjectEvents = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.projectEvents
);

export const selectFocusedProject = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.focusedProject
);

export const selectProjectSearchRequest = createSelector(
  selectProjectsState,
  (state: ProjectsState) => state.searchRequest
);
